import { render } from "./PPromotionRules.vue?vue&type=template&id=580f1610&scoped=true"
import script from "./PPromotionRules.vue?vue&type=script&lang=js"
export * from "./PPromotionRules.vue?vue&type=script&lang=js"

import "./PPromotionRules.vue?vue&type=style&index=0&id=580f1610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f1610"]])

export default __exports__